<template>
  <div>
    <div class="topbar">
      <div class="clearfix main-wrap">
        <a class="pull-left img-back" href="javascript:window.history.go(-1)">返回</a>
        <h1>我的收藏</h1>
      </div>
      <div class="liner"></div>
    </div>


    <mt-loadmore :top-method="loadTop" ref="loadmore">
    <div class="main-page">

      <div class="favorite">
        <ul class="list-group-item large ">
          <li class="list-group" v-for="favorite in getMyContentListInfo.list">
            <div class="liner"></div>
            <router-link class="group-link clearfix" :to="{'path': '/information/detail/' + favorite.contentId}">
              <img class="pull-right" :src="favorite.contentImage ? (getMyContentListInfo.baseAcessPath + favorite.contentImage) : img_default" width="100" height="75" />
              <span class="block group-txt font-12">
                <span class="tit font-16">{{favorite.contentTitle}}</span>
                <span class="data gray">{{favorite.publishTimeString}}</span>
              </span>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
    </mt-loadmore>
  </div>
</template>

<script>
import { service } from '../../../service'
import { mapGetters, mapMutations } from 'vuex'

export default {
  computed: mapGetters({
    getMyContentListInfo: 'getMyContentListInfo'
  }),
  data () {
    return {
      img_default: require('../../../assets/images/ic_no_image.png'),
      cookie_login_data: JSON.parse(window.localStorage['basic_login_data']),
      get_My_Content_List_para: service.setPara('getMyContentList')
      // ListInfo: {}
    }
  },
  mounted: function () {
    this.setPara()
    this.getMyContentListMsg()
  },
  methods: {
    ...mapMutations([
      'receiveFav',
      'clearFav'
    ]),
    loadTop (id) {
      this.$store.dispatch('clearFav')
      this.getMyContentListMsg()
      this.$refs.loadmore.onTopLoaded(id)
    },
    setPara: function () {
      this.get_My_Content_List_para.userId = this.cookie_login_data.teacherId
      this.get_My_Content_List_para.context = this
    },
    getMyContentListMsg: function () {
      this.$store.dispatch('receiveFav', this.get_My_Content_List_para)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// CollectionList.vue?355483b4